export const SCAFFOLD_DATA_LOAD_REQUESTED = 'SCAFFOLD_DATA_LOAD_REQUESTED';
export const SCAFFOLD_DATA_LOAD_SUCCEEDED = 'SCAFFOLD_DATA_LOAD_SUCCEEDED';
export const SCAFFOLD_DATA_LOAD_FAILED = 'SCAFFOLD_DATA_LOAD_FAILED';
export const SCAFFOLD_DATA_LOAD_CANCELED = 'SCAFFOLD_DATA_LOAD_CANCELED';
